import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getDatabase } from "firebase/database";
import { registerFCMToken, updateFCMToken } from "../../services/coreService";

const firebaseConfig = {
  apiKey: "AIzaSyBTtN4eYCdc1_IybkSi7EIU1br52rZy2To",
  authDomain: "bhada24-96846.firebaseapp.com",
  projectId: "bhada24-96846",
  storageBucket: "bhada24-96846.firebasestorage.app",
  messagingSenderId: "200383906913",
  appId: "1:200383906913:web:48a06fb49870731f045620",
  measurementId: "G-SW8DZ4PZT6",
  databaseURL: "https://bhada24-96846-default-rtdb.asia-southeast1.firebasedatabase.app/"
};

let app;
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

const auth = getAuth(app);

let messaging = null;
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.warn("Firebase messaging not supported:", error);
  }
}

const database = getDatabase(app);

export async function requestNotificationPermission() {
  if (!messaging) return null;
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const vapidKey = "BD7Mlk_YLCb6W_IRi91Nsw5KWfOMp1z-ZKimK6scy1wdtQ-f0AhjPKC_9IU3y20t-0ysNCAVfhXvpX6TEWkiI58";
      const token = await getToken(messaging, { vapidKey });
      return token || null;
    }
    return null;
  } catch {
    return null;
  }
}

export const onMessageListener = () => {
  if (!messaging) return Promise.reject("Messaging not available");
  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
};

export const addNotificationToFirebase = async (userId, notificationData) => {
  try {
    const { getDatabase, ref, push } = await import('firebase/database');
    const db = getDatabase();
    const notificationsRef = ref(db, `notifications/${userId}`);
    const notification = {
      ...notificationData,
      timestamp: new Date().toISOString(),
      isRead: false,
      userId: parseInt(userId)
    };
    await push(notificationsRef, notification);
  } catch {}
};

export { app, auth, messaging, database, registerFCMToken, updateFCMToken };